/* LaBalancia — content · EN
   Translated from PL source (rev 1). Keys must never change. */
window.LBQ_CONTENT = window.LBQ_CONTENT || {};
window.LBQ_CONTENT.en = {
  "brama.q": "Who are you to us today?",
  "p_staz.q": "Are you already selling clothing?",
  "p_rytm.q": "What does your sales rhythm look like?",
  "p_marza.q": "Do you know what's left on one dress after every cost?",
  "p_skad.q": "Where do you source your stock today?",
  "p_bol.q": "What frustrates you most?",
  "p_rozm.q": "Which size range sells best for you?",
  "p_cena.q": "What do you charge your customer for a dress?",
  "p_tech.q": "What does your online selling run on?",
  "p_budzet.q": "What budget for a first order?",
  "p_kiedy.q": "When do you want to start?",
  "p_ptak.q": "Have you ever been to Ptak Fashion City?",
  "m_kiedy.q": "When did you last place an order with us?",
  "m_co.q": "What changed?",
  "m_udzial.q": "What share of your range comes from us?",
  "m_luka.q": "What do you have to source elsewhere?",
  "m_popraw.q": "What should we fix so you'd order more?",
  "m_problem.q": "Was there any problem in the last three months?",
  "m_plan.q": "Plans for the coming season?",
  "u_blok.q": "You have an account but haven't ordered yet. What got in the way?",
  "u_co.q": "What would convince you to place a first order?",
  "u_asort.q": "What are you looking for in the catalogue?",
  "d_region.q": "Which region are you in?",
  "i_co.q": "What is your proposal about?",
  "brama.hint": "This decides what we'll ask you about.",
  "p_staz.hint": "The most important question in the whole test.",
  "p_kanal.hint": "Pick your main channel.",
  "p_rytm.hint": "Be honest — this changes the whole diagnosis.",
  "p_marza.hint": "After purchase, shipping, packing and returns.",
  "p_skad.hint": "You can select several sources.",
  "p_bol.hint": "Select up to three.",
  "p_asort.hint": "Select up to three. This decides what we show you at the end.",
  "p_rozm.hint": "Select one or two ranges.",
  "p_cena.hint": "We want to understand which segment you work in — so we can show you collections you'll actually sell. We never display wholesale prices on this page.",
  "p_tech.hint": "This decides which integration path we'll show you.",
  "p_budzet.hint": "It doesn't have to be large — we also work per piece.",
  "p_ptak.hint": "Last question.",
  "m_co.hint": "Be honest — this is the only question that really helps us.",
  "m_luka.hint": "This answer goes straight into our production planning.",
  "m_popraw.hint": "Up to three.",
  "m_plan.hint": "Last question.",
  "u_blok.hint": "No sugar-coating — we want to fix this, not sell you something.",
  "u_asort.hint": "Select up to three.",
  "d_region.hint": "We'll point you to the nearest stockists.",
  "m_co.free": "Add details if you'd like",
  "m_luka.free": "What exactly is missing?",
  "u_blok.free": "Tell us specifically",
  "p_kanal.qAlt": "Where do you plan to sell?",
  "p_kanal.q": "How do you reach your customers?",
  "p_asort.qAlt": "What do you want to trade in?",
  "p_asort.q": "What sells best for you?",
  "p_towar.qAlt": "Where would you like to keep stock?",
  "p_towar.q": "Where does your stock sit today?",
  "brama.o.prospekt": "Looking for a wholesaler, comparing suppliers",
  "brama.s.prospekt": "I sell already or I want to start.",
  "brama.o.partner": "I already have a LaBalancia account",
  "brama.s.partner": "I buy, I used to buy, or I have an account but haven't ordered yet.",
  "brama.o.detal": "Buying for myself, I don't run a business",
  "brama.o.inne": "I'm from an agency or offering services",
  "p_staz.o.roz": "Not yet, I'm considering it",
  "p_staz.o.rok": "I started this year",
  "p_staz.o.ponad": "I've been selling over a year",
  "p_staz.o.kanaly": "For a long time, across several channels",
  "p_kanal.o.butik": "Physical boutique",
  "p_kanal.o.online": "My own online store",
  "p_kanal.o.mp": "Marketplace (Allegro, Amazon, eMAG)",
  "p_kanal.o.social": "Social media and live selling",
  "p_kanal.o.hurt": "I resell wholesale or export",
  "p_kanal.o.marka": "I'm building my own brand",
  "p_kanal.o.nic": "Nowhere yet",
  "p_rytm.o.poj": "Single orders, irregular",
  "p_rytm.o.sez": "Uneven, strongly seasonal",
  "p_rytm.o.reg": "Regular, similar every month",
  "p_rytm.o.ros": "Regular and growing",
  "p_marza.o.nie": "I haven't worked it out precisely",
  "p_marza.o.grubo": "Roughly, yes",
  "p_marza.o.tak": "Exactly — I have it calculated",
  "p_skad.o.ptak": "In person at Ptak / Rzgów",
  "p_skad.o.plhurt": "From Polish online wholesalers",
  "p_skad.o.tr": "Directly from Turkey",
  "p_skad.o.cn": "From China (Alibaba, Shein and similar)",
  "p_skad.o.it": "From Italy",
  "p_skad.o.plprod": "From a Polish manufacturer",
  "p_skad.o.brak": "I'm not buying yet",
  "p_bol.o.jakosc": "Inconsistent quality between deliveries",
  "p_bol.o.rozm": "Sizing doesn't fit the European customer",
  "p_bol.o.termin": "Lead times and delays",
  "p_bol.o.minimum": "Minimum order quantity too high",
  "p_bol.o.tresci": "No photos or descriptions",
  "p_bol.o.zwroty": "Customer returns",
  "p_bol.o.kapital": "Capital tied up in stock",
  "p_bol.o.nowe": "New models arrive too slowly",
  "p_bol.o.klientki": "Not enough customers",
  "p_asort.o.sukienki": "Dresses",
  "p_asort.o.komplety": "Co-ord sets",
  "p_asort.o.bluzki": "Blouses and tops",
  "p_asort.o.doly": "Skirts and trousers",
  "p_asort.o.okrycia": "Sweatshirts, jackets, knitwear",
  "p_asort.o.nocne": "Sleepwear",
  "p_asort.o.szukam": "Still looking for my category",
  "p_rozm.o.sm": "S–M",
  "p_rozm.o.ml": "M–L",
  "p_rozm.o.lxxl": "L–XXL",
  "p_rozm.o.plus": "Plus size, 44+",
  "p_rozm.o.pelny": "Full range — everything sells",
  "p_cena.o.a": "up to 99 zł",
  "p_cena.o.b": "100–159 zł",
  "p_cena.o.c": "160–249 zł",
  "p_cena.o.d": "250–399 zł",
  "p_cena.o.e": "400 zł and above",
  "p_towar.o.zaplecze": "In the boutique back room",
  "p_towar.o.magazyn": "In a warehouse",
  "p_towar.o.dostawca": "At the supplier — they ship it",
  "p_towar.o.nigdzie": "Nowhere, I'm not buying yet",
  "p_tech.o.shopify": "Shopify",
  "p_tech.o.woo": "WooCommerce, Shoper or PrestaShop",
  "p_tech.o.bl": "BaseLinker",
  "p_tech.o.inny": "Another system",
  "p_tech.o.brak": "No system, manually",
  "p_budzet.o.a": "up to 2,000 zł",
  "p_budzet.o.b": "2,000–5,000 zł",
  "p_budzet.o.c": "5,000–15,000 zł",
  "p_budzet.o.d": "over 15,000 zł",
  "p_budzet.o.drop": "No stock — dropshipping only",
  "p_kiedy.o.teraz": "This week",
  "p_kiedy.o.miesiac": "This month",
  "p_kiedy.o.sezon": "Before the new season",
  "p_kiedy.o.patrze": "Just looking around for now",
  "p_ptak.o.reg": "I go regularly",
  "p_ptak.o.raz": "I've been once",
  "p_ptak.o.online": "I only buy online",
  "p_ptak.o.chce": "No, but I'd like to visit",
  "m_kiedy.o.nigdy": "I haven't ordered yet",
  "m_kiedy.s.nigdy": "I have an account, but no first order happened.",
  "m_kiedy.o.teraz": "This month",
  "m_kiedy.o.kwartal": "1–3 months ago",
  "m_kiedy.o.pol": "Over six months ago",
  "m_kiedy.o.niepam": "I don't remember",
  "m_co.o.inny": "I found another supplier",
  "m_co.o.asort": "The range stopped fitting",
  "m_co.o.problem": "There was a problem with an order",
  "m_co.o.biznes": "My situation changed",
  "m_co.o.nic": "Nothing, just a break",
  "m_udzial.o.a": "Under 10%",
  "m_udzial.o.b": "Around 25%",
  "m_udzial.o.c": "About half",
  "m_udzial.o.d": "75% and more",
  "m_luka.o.duze": "Larger sizes",
  "m_luka.o.zima": "Winter outerwear",
  "m_luka.o.wiecz": "Elegant, eveningwear",
  "m_luka.o.basic": "Everyday basics",
  "m_luka.o.dod": "Accessories",
  "m_luka.o.tanie": "Lower price bracket",
  "m_luka.o.drogie": "Higher price bracket",
  "m_luka.o.nic": "Nothing — you cover my needs",
  "m_popraw.o.stany": "Stock depth",
  "m_popraw.o.nowe": "Pace of new models",
  "m_popraw.o.rozm": "Size range",
  "m_popraw.o.ceny": "Prices",
  "m_popraw.o.wysylka": "Shipping costs",
  "m_popraw.o.platnosc": "Payment terms",
  "m_popraw.o.xml": "Quality of the XML file",
  "m_popraw.o.opiekun": "Contact with account manager",
  "m_problem.o.nie": "No, everything was fine",
  "m_problem.o.jakosc": "Quality",
  "m_problem.o.opozn": "Delay",
  "m_problem.o.braki": "Missing items in the order",
  "m_problem.o.rozlicz": "Billing",
  "m_plan.o.rozwoj": "I'm growing",
  "m_plan.o.bez": "No change",
  "m_plan.o.ogr": "I'm scaling back",
  "m_plan.o.kanal": "I'm opening a new channel",
  "u_blok.o.brak": "I couldn't find what I'm looking for",
  "u_blok.o.ceny": "Prices don't match my bracket",
  "u_blok.o.jak": "I don't know how to start",
  "u_blok.o.sezon": "I'm waiting for the season",
  "u_blok.o.porown": "I'm still comparing suppliers",
  "u_blok.o.formal": "Paperwork and billing",
  "u_co.o.probka": "A trial order of a few pieces",
  "u_co.o.rozmowa": "A call with an account manager",
  "u_co.o.wizyta": "Seeing the stock in person at Ptak",
  "u_co.o.zdjecia": "Better photos and descriptions",
  "u_co.o.nic": "Nothing for now, I'm watching",
  "u_asort.o.sukienki": "Dresses",
  "u_asort.o.komplety": "Co-ord sets",
  "u_asort.o.bluzki": "Blouses and tops",
  "u_asort.o.doly": "Skirts and trousers",
  "u_asort.o.okrycia": "Outerwear",
  "u_asort.o.nocne": "Sleepwear",
  "d_region.o.lodz": "Łódź region",
  "d_region.o.mazow": "Mazovia",
  "d_region.o.slask": "Silesia",
  "d_region.o.wlkp": "Greater Poland",
  "d_region.o.malop": "Lesser Poland",
  "d_region.o.inne": "Other / abroad",
  "i_co.o.uslugi": "Marketing or IT services",
  "i_co.o.logist": "Logistics or courier",
  "i_co.o.produkcja": "Production or materials",
  "i_co.o.inne2": "Something else",
  "tag.butik": "boutique",
  "tag.sklep_online": "online store",
  "tag.marketplace": "marketplace",
  "tag.social_selling": "social selling",
  "tag.hurt_eksport": "wholesale / export",
  "tag.własna_marka": "own brand",
  "tag.przed_startem": "pre-launch",
  "tag.marża_nieliczona": "margin not calculated",
  "tag.marża_szacowana": "margin estimated",
  "tag.marża_policzona": "margin calculated",
  "tag.zakupy_w_Ptaku": "buys at Ptak",
  "tag.hurtownie_PL": "PL wholesalers",
  "tag.import_TR": "import TR",
  "tag.import_CN": "import CN",
  "tag.import_IT": "import IT",
  "tag.producent_PL": "PL manufacturer",
  "tag.bez_dostawcy": "no supplier",
  "tag.jakość": "quality",
  "tag.rozmiarówka": "sizing",
  "tag.terminy": "lead times",
  "tag.wysokie_MOQ": "high MOQ",
  "tag.brak_treści": "no content",
  "tag.zwroty": "returns",
  "tag.kapitał": "capital",
  "tag.tempo_nowości": "pace of newness",
  "tag.ruch": "traffic",
  "tag.sukienki": "dresses",
  "tag.komplety": "co-ord sets",
  "tag.bluzki": "blouses",
  "tag.doły": "bottoms",
  "tag.okrycia": "outerwear",
  "tag.piżamy": "sleepwear",
  "tag.kategoria_otwarta": "category open",
  "tag.S_M": "S–M",
  "tag.M_L": "M–L",
  "tag.L_XXL": "L–XXL",
  "tag.plus_size": "plus size",
  "tag.pełna_rozmiarówka": "full size range",
  "tag.półka_99_zł": "bracket ≤99 zł",
  "tag.półka_100_159": "bracket 100–159",
  "tag.półka_160_249": "bracket 160–249",
  "tag.półka_250_399": "bracket 250–399",
  "tag.półka_400_": "bracket 400+",
  "tag.zaplecze": "back room",
  "tag.magazyn": "warehouse",
  "tag.bez_magazynu": "no warehouse",
  "tag.przed_pierwszym_zakupem": "before first purchase",
  "tag.Shopify": "Shopify",
  "tag.WooCommerce_Shoper": "WooCommerce/Shoper",
  "tag.BaseLinker": "BaseLinker",
  "tag.inny_system": "other system",
  "tag.ręcznie": "manual",
  "tag.budżet_2_tys_": "budget ≤2k",
  "tag.budżet_2_5_tys_": "budget 2–5k",
  "tag.budżet_5_15_tys_": "budget 5–15k",
  "tag.budżet_15_tys_": "budget 15k+",
  "tag.bez_zakupu_towaru": "no stock purchase",
  "tag.start_ten_tydzień": "start: this week",
  "tag.start_ten_miesiąc": "start: this month",
  "tag.start_nowy_sezon": "start: new season",
  "tag.rozgląda_się": "just looking",
  "tag.bywa_w_Ptaku": "visits Ptak",
  "tag.był_raz": "visited once",
  "tag.tylko_online": "online only",
  "tag.chce_przyjechać": "wants to visit",
  "tag.aktywny": "active",
  "tag.1_3_mies_": "1–3 months",
  "tag.uśpiony_6m_": "dormant 6m+",
  "tag.uśpiony": "dormant",
  "tag.odejście_do_konkurencji": "moved to competitor",
  "tag.niedopasowanie_oferty": "range mismatch",
  "tag.problem_operacyjny": "operational problem",
  "tag.zmiana_u_klienta": "change on client side",
  "tag.naturalna_przerwa": "natural break",
  "tag.udział_10_": "share <10%",
  "tag.udział_25_": "share ~25%",
  "tag.udział_50_": "share ~50%",
  "tag.udział_75_": "share 75%+",
  "tag.luka_duże_rozmiary": "gap: larger sizes",
  "tag.luka_okrycia": "gap: outerwear",
  "tag.luka_wieczorowe": "gap: eveningwear",
  "tag.luka_basic": "gap: basics",
  "tag.luka_dodatki": "gap: accessories",
  "tag.luka_niższa_półka": "gap: lower bracket",
  "tag.luka_wyższa_półka": "gap: higher bracket",
  "tag.brak_luki": "no gap",
  "tag.popraw_stany": "fix: stock depth",
  "tag.popraw_nowości": "fix: newness",
  "tag.popraw_rozmiary": "fix: sizes",
  "tag.popraw_ceny": "fix: prices",
  "tag.popraw_wysyłka": "fix: shipping",
  "tag.popraw_płatności": "fix: payment terms",
  "tag.popraw_XML": "fix: XML",
  "tag.popraw_kontakt": "fix: contact",
  "tag.problem_jakość": "problem: quality",
  "tag.problem_opóźnienie": "problem: delay",
  "tag.problem_braki": "problem: missing items",
  "tag.problem_rozliczenia": "problem: billing",
  "tag.plan_rozwój": "plan: growth",
  "tag.plan_bez_zmian": "plan: no change",
  "tag.plan_ograniczenie": "plan: scaling back",
  "tag.plan_nowy_kanał": "plan: new channel",
  "tag.brak_asortymentu": "range not found",
  "tag.niedopasowana_półka": "bracket mismatch",
  "tag.brak_onboardingu": "no onboarding",
  "tag.czeka_na_sezon": "waiting for season",
  "tag.w_porównaniu": "comparing",
  "tag.blokada_formalna": "paperwork blocker",
  "tag.chce_próbki": "wants a sample order",
  "tag.chce_rozmowy": "wants a call",
  "tag.chce_wizyty": "wants a visit",
  "tag.chce_treści": "wants content",
  "tag.obserwuje": "observing",
  "etap0.n": "You're considering it",
  "etap1.n": "First steps",
  "etap2.n": "Finding your rhythm",
  "etap3.n": "Steady sales",
  "etap4.n": "Own brand",
  "etap0.pod": "Stage 0",
  "etap1.pod": "Stage 1",
  "etap2.pod": "Stage 2",
  "etap3.pod": "Stage 3",
  "etap4.pod": "Stage 4",
  "etap0.sig": "You haven't bought stock yet",
  "etap1.sig": "First orders, no repeatability",
  "etap2.sig": "Turnover exists, regularity doesn't",
  "etap3.sig": "Repeatable turnover, rotation data",
  "etap4.sig": "Several channels or your own label",
  "etap0.pri": "Proof that someone will buy",
  "etap1.pri": "Narrow the range and calculate margin",
  "etap2.pri": "The maths: margin, returns, rotation",
  "etap3.pri": "Deepen bestsellers and automate",
  "etap4.pri": "Differentiation and exclusivity",
  "etap0.blad": "Buying stock before finding the customer",
  "etap1.blad": "Too many styles, too few pieces",
  "etap2.blad": "Rescuing the season with discounts",
  "etap3.blad": "Scaling the whole range at once",
  "etap4.blad": "Selling the same as everyone else",
  "etap0.h": "You haven't bought stock yet. This is the best moment to avoid the most expensive mistake in this industry.",
  "etap1.h": "You have your first orders. This is where it's decided whether this becomes a business or an expensive hobby.",
  "etap2.h": "Turnover is there, regularity isn't. Usually the problem isn't selling — it's the maths.",
  "etap3.h": "Sales are repeatable. The question is no longer \"whether\", but \"what exactly to multiply\".",
  "etap4.h": "You sell across several channels or you're building your own brand. The problem isn't selling — it's standing out.",
  "etap0.diag": "Most people start by buying stock and then look for customers. That's the wrong order and it costs the most — the stock sits, the money sits, and the market moves on. Reverse it: first check you have someone to sell to, then buy, and buy little.",
  "etap1.diag": "The most common mistake at this stage: too many styles, too few pieces of each. It looks like a rich offer but behaves like a leftovers warehouse — when a style takes off, you don't have it in sizes. Fifteen styles in depth beat sixty in single pieces.",
  "etap2.diag": "This stage lasts longest and most often ends quietly. The reason is almost always the same: turnover grows and nobody counts what's left of it. Markdowns eat the margin, returns aren't counted in, shipping sits somewhere in costs. Until you know your margin per piece, every decision is a guess.",
  "etap3.diag": "The risk here is scaling everything at once. You scale the bottleneck and the bestsellers, not the entire range. The second typical mistake: buying whole seasonal collections when the rotation data says twenty percent of the offer is doing the work.",
  "etap4.diag": "The biggest threat is selling the same thing as everyone else. The same dress in fifteen stores ends in a price war nobody wins. The answer is exclusivity, your own label, or a distinctive selection.",
  "etap0.my": "At this stage you don't need a wholesaler — you need proof. If you want to test the market without buying stock, dropshipping was made for exactly that. The account is free but requires a tax ID.",
  "etap1.my": "A trial order per piece makes sense here — you check quality and sizing without tying up capital. If our bracket turns out not to fit your customer, we'll say so plainly and point you to what to look for.",
  "etap2.my": "If the problem is capital tied up in stock, a mixed model works well: you keep bestsellers in house and sell the rest of the catalogue without a warehouse.",
  "etap3.my": "Standing stock, the loyalty programme and a showroom visit all make sense now — at this scale one visit replaces dozens of emails.",
  "etap4.my": "We produce in Poland — in Katowice, Rzgów and Piotrków Trybunalski — so labels, packaging and short runs are arranged individually. This is the only stage where a conversation about your own brand truly makes sense.",
  "etap0.skup.0": "Find your customer before you buy anything. Age, size, occasion, what she spends on a dress. If you can't describe her in two sentences, it's too early to shop.",
  "etap0.skup.1": "Check whether there's room in your area or niche. Count the competition, look at their prices and range.",
  "etap0.skup.2": "Run a test without stock: dropshipping or a few pieces. The goal isn't profit, it's proof.",
  "etap1.skup.0": "Narrow down. Fifteen to thirty styles is enough to see what moves.",
  "etap1.skup.1": "Calculate the margin on one piece with every cost included — the calculator is below.",
  "etap1.skup.2": "Build repeatability. One good sale is chance; the same sale three weeks running is a model.",
  "etap2.skup.0": "Calculate margin per category separately — dresses, co-ords and outerwear behave differently.",
  "etap2.skup.1": "Introduce a rotation test: a style with no sales for two months doesn't deserve a reorder.",
  "etap2.skup.2": "Stabilise supply. Uneven sales often come from uneven stocking, not weak demand.",
  "etap3.skup.0": "Find the twenty percent of styles driving most of your turnover and deepen them in sizes.",
  "etap3.skup.1": "Secure continuity of supply — running out now costs more than overstocking.",
  "etap3.skup.2": "Automate the repetitive: catalogue via XML or BaseLinker, stock levels, descriptions.",
  "etap4.skup.0": "Build recognition that can't be copied: your own label, short runs, a distinctive selection.",
  "etap4.skup.1": "Separate channel profitability — a marketplace and your own store have different economics.",
  "etap4.skup.2": "Secure supply where you have an edge. Exclusivity is worth more than a discount.",
  "etap0.nie.0": "Don't buy a seasonal collection — it ties up capital for months.",
  "etap0.nie.1": "Don't take the full size range in every style.",
  "etap0.nie.2": "Don't invest in a logo and photoshoots before your first sale.",
  "etap1.nie.0": "Don't widen the range until you know what rotates.",
  "etap1.nie.1": "Don't compete on price — you don't have the scale yet.",
  "etap1.nie.2": "Don't buy under your own label. That's a stage four decision.",
  "etap2.nie.0": "Don't rescue the season with discounts — it solves a warehouse problem and creates a margin problem.",
  "etap2.nie.1": "Don't add channels until one works predictably.",
  "etap3.nie.0": "Don't enter a new channel if the current one has no spare capacity.",
  "etap3.nie.1": "Don't buy the season by eye when you have rotation data.",
  "etap4.nie.0": "Don't sell the same range at the same price in every channel.",
  "etap4.nie.1": "Don't build a brand on stock available to everyone.",
  "etap0.m30.0": "Whether anyone bought — even a single piece",
  "etap0.m30.1": "What it cost to reach that one person",
  "etap1.m30.0": "Rotation: how many pieces of the first delivery sold",
  "etap1.m30.1": "Net margin per piece, after returns and shipping",
  "etap2.m30.0": "Gross margin per category",
  "etap2.m30.1": "Share of markdowns in turnover",
  "etap3.m30.0": "Share of bestsellers in turnover",
  "etap3.m30.1": "How much sales you lost to stockouts",
  "etap4.m30.0": "Margin per channel",
  "etap4.m30.1": "Share of range the competition doesn't have",
  "etap0.m90.0": "Whether sales repeat without your constant effort",
  "etap0.m90.1": "Whether you can describe who buys and why",
  "etap1.m90.0": "Which styles sold twice",
  "etap1.m90.1": "Cost of acquiring one customer",
  "etap2.m90.0": "Rotation in weeks per style",
  "etap2.m90.1": "What percentage of customers return",
  "etap3.m90.0": "Margin after scaling — it often drops as volume grows",
  "etap3.m90.1": "Profitability of each channel separately",
  "etap4.m90.0": "Customer return rate",
  "etap4.m90.1": "Own line profitability versus reselling",
  "pasma0.v": "2–2.5×",
  "pasma0.t": "typical retail markup over wholesale price",
  "pasma1.v": "8–10 wks",
  "pasma1.t": "after this long without a sale a style counts as non-rotating",
  "pasma2.v": "15–30%",
  "pasma2.t": "typical share of returns in online sales",
  "pasma3.v": "up to 20%",
  "pasma3.t": "healthy share of markdowns in annual turnover",
  "pasma4.v": "20/80",
  "pasma4.t": "usually a fifth of styles drives most of the turnover",
  "link.katalog": "New arrivals",
  "link.sztuki": "Buying per piece",
  "link.drop": "Terms of cooperation",
  "link.xml": "XML file",
  "link.lojal": "Loyalty programme",
  "link.marka": "BrandLaBalancia",
  "link.prod": "Polish production",
  "link.hurt": "Wholesale offer",
  "link.detal": "Retail stockists",
  "ui.003": "The Łódź region is closest to us — the showroom is at Ptak Fashion City in Rzgów, and most boutiques carrying our clothing are here.",
  "ui.004": "In Mazovia you'll find our pieces in partner boutiques; the list of stockists is kept up to date.",
  "ui.005": "In Silesia we work with physical boutiques — check the list of stockists before you travel.",
  "ui.006": "In Greater Poland we have both physical and online partners.",
  "ui.007": "In Lesser Poland our pieces are sold mainly by physical boutiques.",
  "ui.008": "Outside these regions most of our partners sell online — delivery reaches you just as quickly.",
  "ui.009": "We review marketing and IT proposals once a quarter.",
  "ui.010": "Courier and logistics offers go to our operations team — write with concrete rates for parcels up to 2 kg within Poland and the EU, that's the fastest route.",
  "ui.011": "Production and materials offers go straight to our factory — add which fabrics or services you mean and what the minimum runs are.",
  "ui.012": "That's movement forward.",
  "ui.013": "Something has slipped back — worth checking what changed in your sales rhythm.",
  "ui.014": "What usually happens at this stage",
  "ui.015": "Cooperation model: ",
  "ui.016": "Your price bracket and sizing",
  "ui.017": "Your next step",
  "ui.018": "Metrics for 30 days",
  "ui.019": "Metrics for 90 days",
  "ui.020": "Where we fit into this",
  "ui.021": "We want to know what went wrong",
  "ui.022": "Your cooperation profile",
  "ui.023": "Thank you for being straight with us. We won't try to sell you anything now — first we want to understand what happened.",
  "ui.024": "Below is what follows from your answers. Any gap you flagged goes straight into collection planning.",
  "ui.025": "You found another supplier. That's normal and we won't try to talk you out of it — but if you tell us what's better there, we'll use it. Competitors are a cheaper source of insight for us than research.",
  "ui.026": "The range stopped fitting. That's the most important thing in this whole survey: we record it against your account and come back to you when a delivery matching what was missing arrives.",
  "ui.027": "There was a problem with an order. Before we propose anything, we want to close it — your account manager will come back with a concrete answer, including if it's \"that was our mistake\".",
  "ui.028": "Your situation changed. The account stays active with no conditions; come back when it makes sense.",
  "ui.029": "Just a break — that happens. Tell us what you're looking for this season and we'll prepare a selection instead of sending the whole catalogue.",
  "ui.030": "Reported problem",
  "ui.031": "Gap in the range",
  "ui.032": "stock depth",
  "ui.033": "pace of new models arriving",
  "ui.034": "size range",
  "ui.035": "shipping costs",
  "ui.036": "payment terms",
  "ui.037": "quality of the XML file",
  "ui.038": ". These points go to your account manager together with your account number — not as a survey, but as a list to answer. ",
  "ui.039": "Under 10% of your range comes from us. That means either you don't know the full catalogue yet, or something specific doesn't fit — in both cases we want to know what.",
  "ui.040": "About a quarter of your range comes from us. Usually that means one category works and the rest hasn't been tested yet.",
  "ui.041": "About half your range comes from us — you're a partner to us, not a catalogue customer. At this scale it's worth discussing standing terms.",
  "ui.042": "Over three quarters of your range comes from us. That obliges us: at this share, every stock slip on our side is your problem, not just ours.",
  "ui.043": "Your share of our catalogue",
  "ui.044": "Your plans",
  "ui.045": "New channel",
  "ui.046": "Write us one sentence about what you're looking for — we'll pick items by hand.",
  "ui.047": "Tell us which category you're after. The catalogue is wider than the homepage, and some items rotate fast.",
  "ui.048": "Tell us the price bracket you sell in. If our offer doesn't match it, we'll say so plainly.",
  "ui.049": "Order a few pieces as a trial. No commitments, no collection minimum — the point is for you to feel the quality in your hands.",
  "ui.050": "Give us the month you want to start. We'll reach out ahead of time when the right collection arrives.",
  "ui.051": "Keep comparing — that's sensible. Ask us for concrete data: sizing, lead times, shipping costs. We'll answer with numbers.",
  "ui.052": "Tell us what exactly got stuck. Paperwork issues are usually resolved in one email.",
  "ui.053": "We can start a trial order right away — no collection minimum, single pieces.",
  "ui.054": "We arrange a call with an account manager within one working day; leave your number in the form below.",
  "ui.055": "The showroom is at Ptak Fashion City in Rzgów. Tell us when you plan to visit — we'll prepare a selection instead of searching on the spot.",
  "ui.056": "Photos and descriptions come ready in the XML or CSV file; you don't have to photograph anything yourself.",
  "ui.057": "We won't push you. The account stays active and you can browse the catalogue whenever you like.",
  "ui.058": "At these numbers you lose money on every sale. Returns, shipping and VAT eat the whole margin — this is the most common reason shops close quietly.",
  "ui.059": "A healthy level. You have room to mark down leftovers without going under.",
  "ui.060": "Markup below twice the purchase price. In clothing that's usually too little to cover misjudged styles and end-of-season leftovers.",
  "ui.061": "The margin is thin. One misjudged delivery or a rise in returns is enough to break even at zero.",
  "ui.062": " net / selling ",
  "ui.063": "%, resold ",
  "ui.064": " Wholesale prices are visible after opening a B2B account (tax ID required).",
  "ui.065": "Privacy policy",
  "ui.066": "I agree",
  "ui.067": "Don't remember me",
  "ui.068": "Signal",
  "ui.069": "Typical mistake",
  "ui.070": "Read the result to the end",
  "ui.071": "You'll find our clothing at retail partners",
  "ui.072": "See stockists",
  "ui.073": "Thank you for your proposal",
  "ui.074": "What to focus on now",
  "ui.075": "What not to do now",
  "ui.076": "Reference points from the market, not rules. They differ between channels and price brackets.",
  "ui.077": "Start browsing here",
  "ui.078": "Selected for your category. Wholesale prices visible after logging in.",
  "ui.079": "Cooperation review",
  "ui.080": "We record the gaps you flagged against your account. When a matching delivery arrives, you hear about it before the catalogue goes live.",
  "ui.081": "You're scaling back. We won't paper over that with an offer — if the reason is on our side, write one sentence and your account manager will handle it, not a salesperson.",
  "ui.082": "You're opening a new channel — this is the moment when catalogue integration saves the most time. An XML file or BaseLinker lets you list the range without retyping data.",
  "ui.083": "Your account manager comes back with an answer to what you flagged.",
  "ui.084": "You get a list of items matching your gap.",
  "ui.085": "If the scale justifies it — we discuss standing terms or a showroom visit.",
  "ui.086": "You have an account, but the start never happened",
  "ui.087": "This happens more often than you'd think, and it's almost always solved with one concrete step.",
  "ui.088": "Worth starting here",
  "ui.089": "You can open the catalogue directly:",
  "ui.090": "See the full catalogue",
  "ui.091": "Work out what's really left on one piece",
  "ui.092": "The numbers stay with you. We only receive them if you choose to send them.",
  "ui.093": "Selling price",
  "ui.094": "Shipping you cover",
  "ui.095": "Channel commission (%)",
  "ui.096": "Your profit target",
  "ui.097": "Share of returns resold",
  "ui.098": "Selling price net",
  "ui.099": "Margin on net price",
  "ui.100": "Want this by email with our comment on it?",
  "ui.101": "Send",
  "ui.102": "Open a B2B account",
  "ui.103": "See exactly what will be sent",
  "ui.104": "Continue",
  "ui.105": "Last time you came out at",
  "ui.106": ". Check whether anything has changed.",
  "ui.107": "We recognise your B2B account — we'll skip questions we already know the answer to.",
  "ui.108": "Answer honestly, including when the answer doesn't look good.",
  "ui.109": "A diagnosis is worth exactly as much truth as you put into it. We don't ask for your email to begin.",
  "ui.110": "Thank you — your message arrived.",
  "ui.111": "We usually reply within one working day.",
  "ui.112": "We'll remember your answers in this browser, ",
  "ui.113": "LaBalancia is a wholesaler — we sell only to businesses. You'll find our pieces in boutiques across Poland.",
  "ui.114": ". We only get in touch when the subject is current for us —",
  "ui.115": "Last time you came out at stage ",
  "ui.116": "We noted: \"",
  "ui.117": "You flagged:",
  "ui.118": "We reply with specifics for your situation, usually within one working day.",
  "ui.119": "I agree to be contacted about this enquiry and to send my answers along with it.",
  "ui.120": "You have unfinished answers from a previous visit.",
  "ui.121": "so you don't start from zero and so we can show you what changed on your next visit. ",
  "ui.122": "Preview ",
  "ui.123": " orders",
  "ui.124": "Considering",
  "ui.125": "We'll choose the model later",
  "ui.126": "At this stage, choosing between wholesale and dropshipping is premature — you don't yet have the data to make that call. Start with proof that someone will buy: a few pieces, or dropshipping with no stock purchase. We'll pick the model once you know what sells.",
  "ui.127": "Dropshipping — selling without a warehouse",
  "ui.128": "Your answers suggest capital and logistics are a bigger constraint for you today than margin. You take the order and collect payment; we pick, pack and ship a neutral parcel straight to your customer. The dropshipping price is the wholesale price plus a service fee. We don't accept returns; for a faulty item we handle an exchange.",
  "ui.129": "Wholesale — you buy stock on your own terms",
  "ui.130": "You have somewhere to keep stock and you care about the highest margin. You buy at net wholesale prices, set your own retail price and ship when you choose. Prepayment applies. In wholesale we don't accept returns, but exchanges are possible; return shipping is covered by the partner.",
  "ui.131": "The scales don't tip clearly either way — and that's the most common setup among shops that are growing. You keep a dozen or so proven styles in house and sell the rest of the catalogue with no risk. You run both models from one account and one catalogue file — just remember the return rules differ.",
  "ui.132": "You're on Shopify, so the shortest path is an XML or CSV file pulled straight into your store. Photos, descriptions, EAN codes and stock levels update automatically — no photoshoot needed on your side.",
  "ui.133": "WooCommerce, Shoper and PrestaShop all handle our XML or CSV file. After import you immediately have photos, descriptions, EAN codes and live stock levels.",
  "ui.134": "You work with BaseLinker — for us that's the simplest option. You pull the catalogue and stock into the panel and pass orders back the same way, without retyping data.",
  "ui.135": "We'll check your system individually. We provide XML and CSV files and most platforms can take them — tell us what you work on and we'll confirm before you start.",
  "ui.136": "You sell manually today and that's fine to start with. You'll see the catalogue, photos and stock once your account is open. When you launch online selling, we add an XML or CSV file or a BaseLinker connection.",
  "ui.137": "You work in the lowest price bracket. We sew in Poland in shorter runs, so at this retail price the maths tends to be tight — run it through the calculator below before you order anything. If it doesn't add up, we'll say so plainly. A common solution then is a few individual styles as a top-up to your range, rather than full stocking.",
  "ui.138": "This is the lower boundary where our offer usually adds up. It works if you keep a markup of at least two times and watch your returns. Start with a trial order before you tie up capital.",
  "ui.139": "This is our core. Here we have the widest choice of styles and the deepest stock, so restocking bestsellers is easiest.",
  "ui.140": "This bracket works well with us when the selection is distinctive — not volume, but choice. It's worth discussing shorter runs so you're not selling the same thing as the shop next door.",
  "ui.141": "In this bracket exclusivity is what counts. The catalogue alone isn't enough — a conversation about short runs or your own label makes sense, otherwise your customer will find the same dress cheaper elsewhere.",
  "ui.142": "You flagged larger sizes as your core. We ask because availability in that range can be uneven — when ordering, tell us which sizes are critical for you and we'll check stock before confirming.",
  "ui.143": "You carry the full size range, so stock depth matters more than the number of styles. When restocking, watch the middle of the range — it moves fastest and runs out most often.",
  "ui.144": "You want to move fast on a small budget — start with single pieces or dropshipping. Opening an account takes a few minutes; you'll need a tax ID.",
  "ui.145": "At this budget and this timing it's worth booking a call rather than placing a catalogue order — we'll select the range for your bracket and sizing.",
  "ui.146": "Timing and budget line up. Fastest route: a B2B account, a trial order per piece, then restock whatever rotated.",
  "ui.147": "You're starting before the new season, so you have time to test. Order a few pieces now to check quality and sizing, and go into the season with knowledge instead of an assumption.",
  "ui.148": "You're looking around and that's sensible. You don't need to sign up for anything — read the terms of cooperation and shipping costs, and come back when you're ready.",
  "ui.149": "You want to see the stock in person: the showroom is at Ptak Fashion City in Rzgów. Tell us when you plan to come and we'll prepare a selection for your bracket.",
  "ui.150": "You visit Ptak — email us before your next trip and we'll have styles from your category ready instead of you hunting for them on site.",
  "ui.151": "Importing from China plus a returns problem is usually one and the same thing: sizing cut for a different body. A return costs you twice — the shipping and the lost sale.",
  "ui.152": "With overseas imports, delivery time eats the season. Stock that arrives after peak demand sells at a discount.",
  "ui.153": "Sizing is the most common reason imports from Turkey stop working at greater scale. Compare measurement tables, not letter labels.",
  "ui.154": "If new models appear too slowly, you're selling the same thing as the shop next door and competing on price alone.",
  "ui.155": "A high minimum and tied-up capital are the same wound. A supplier demanding large batches shifts the risk of guessing taste onto you.",
  "ui.156": "Missing photos and descriptions decide how many styles you can list in a month. A photoshoot is a hidden cost — count it alongside the price of the goods.",
  "ui.157": "Inconsistent quality between deliveries usually doesn't come from one bad shipment, but from the supplier changing workshops between batches. Check whether your supplier actually produces or just intermediates — that's the one question that settles it.",
  "ui.158": "Not enough customers is the only pain on this list that changing supplier won't solve. Before you go looking for new stock, check whether the problem is reach — otherwise you'll buy a better collection and sell it just as slowly.",
  "ui.159": "at the bottom of the page. We'll add a comment on your specific situation and reply within one working day.</p>",
  "ui.160": "we don't want to waste your time on courtesy correspondence.</p></div></div>",
  "ui.161": "<div class=\"note\">The report goes to your account manager as a priority. We reply within one working day — including when the answer is \u201ethat was our mistake\".</div>",
  "ui.162": "Some we'll answer straight away, some need a week, but we'll answer every one.</p>",
  "ui.163": " zł (",
  "ui.164": "<div class=\"fld\"><label class=\"fl\" for=\"lbqB\">Your question</label><textarea id=\"lbqB\" name=\"contact[body]\" placeholder=\"Write in your own words — we'll answer that, not the form.\"></textarea></div>",
  "ui.165": "In the meantime you can browse the catalogue or work out your margin.",
  "ui.166": "See the catalogue",
  "ui.200": "A guide for boutiques and shops",
  "ui.201": "Every shop goes through<br><em>five stages</em>.",
  "ui.202": "At each of them something different makes sense — and something different is an expensive mistake. Answer a few questions about how you really sell today and we'll tell you where you are, what to do now and what you'd better not start yet.",
  "ui.203": "Check your stage",
  "ui.204": "Margin calculator",
  "ui.205": "We are a manufacturer, not a middleman.",
  "ui.206": "<strong>We produce in Poland.</strong> We sew in Katowice, Rzgów and Piotrków Trybunalski. You can see the collection in person at our shop in Ptak Fashion City in Rzgów near Łódź.",
  "ui.207": "We sell only to businesses. Registration requires a tax ID, and wholesale prices appear only after logging in. Never publicly — because your margin is your business, not information for your competitors.",
  "ui.208": "<strong>We work with very different shops</strong> — from a first boutique to a chain running several channels. We don't fit everyone equally, and we'd rather check that together before you spend your first money. That's why we ask about your price bracket and sizing: if our collection doesn't match your customer, we'll say so calmly and point you to what to look for. We'd rather have fewer partners we genuinely help than many who leave after the first season.",
  "ui.209": "This tool is not a contact form in disguise. You can go through the whole test, read the diagnosis, calculate your margin and leave — without giving an email address.",
  "ui.210": "Map of stages",
  "ui.211": "Five stages, five different sets of decisions.",
  "ui.212": "The whole map is public. You can read it without filling in anything — the test only exists to point out which chapter is yours.",
  "ui.213": "The tool",
  "ui.214": "The diagnosis takes about a minute.",
  "ui.215": "Eight to ten questions, depending on your answers. The path branches — a physical boutique gets different questions than a marketplace seller. The result isn't a points total: if you haven't calculated your margin, you won't land above stage two, whatever your turnover.",
  "ui.216": "Let's start",
  "ui.217": "Calculate your margin first",
  "ui.218": "Result preview",
  "ui.219": "Sales rhythm",
  "ui.220": "irregular",
  "ui.221": "Margin calculated",
  "ui.222": "no",
  "ui.223": "Capital in stock",
  "ui.224": "high",
  "ui.225": "Model",
  "ui.226": "mixed",
  "ui.227": "Profile match · 62%",
  "ui.228": "stages of growth",
  "ui.229": "diagnosis time",
  "ui.230": "shop languages",
  "ui.231": "locations in Poland",
  "ui.232": "Integrations",
  "ui.233": "The catalogue goes into your system.",
  "ui.234": "Photos, descriptions, EAN codes and stock levels are pulled automatically. No photoshoot needed on your side.",
  "ui.235": "Catalogue, stock and orders in one panel",
  "ui.236": "XML or CSV import straight into your store",
  "ui.237": "Also Shoper and PrestaShop",
  "ui.238": "A universal route into any system",
  "ui.239": "COMPOSITION",
  "ui.240": "Polish production",
  "ui.241": "middlemen",
  "ui.242": "B2B only — tax ID required",
  "ui.243": "CARE INSTRUCTIONS",
  "ui.244": "Do not sell below the suggested price",
  "ui.245": "Calculate margin before scaling up",
  "ui.246": "Order a sample before tying up capital",
  "ui.247": "Do not rescue the season with discounts",
  "ui.248": "Ask directly — we answer with numbers",
  "ui.249": "SHOP",
  "ui.250": "PRODUCTION",
  "ui.251": "CONTACT",
  "ui.252": "THANK YOU FOR YOUR VISIT",
  "ui.253": "Come back whenever you like.",
  "ui.254": "Stage diagnostics",
  "ui.255": "Close",
  "ui.256": "Go to the diagnostics",
  "ui.257": "Your diagnosis",
  "ui.258": "Start again",
  "ui.259": "Go to the form",
  "ui.260": "Want a comment on your result? Leave your email — we reply within one working day.",
  "ui.261": "We don't ask for your email to begin. You can stop at any time.",
  "ui.262": "We collect anonymous answer statistics to improve this tool — without identifiers and without anything you write in your own words.",
  "ui.263": "Enter your numbers. We send nothing — the result stays in your browser.",
  "ui.264": "Known:",
  "ui.265": "Diagnostics",
  "ui.266": "<b>How we calculate.</b> We convert the selling price to net, because the purchase price is net too — comparing gross with net inflates the margin by well over ten points. A return costs double shipping, the packaging and the share of goods that doesn't come back for resale. The result is margin on the goods, not company profit: rent, advertising and your own work sit outside this calculation."
};